import PageLoading from "components/PageLoading";

export const PageLoadingProgress = () => {
  return (
    <div>
      <PageLoading />
    </div>
  );
};
